import React from 'react';
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Modal,
  Typography,
} from '@mui/material';
import {
  Close as CloseIcon,
  HowToReg as HowToRegIcon,
} from '@mui/icons-material';
import CustomButton from '../../../../components/General/CustomButton';
import useStyles from './styles';

interface EnableEnrollmentModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

function EnableEnrollmentModal({
  open,
  onClose,
  onConfirm,
  loading = false,
}: EnableEnrollmentModalProps) {
  const classes = useStyles();

  return (
    <Modal open={open} onClose={onClose}>
      <Box className={classes.modalContainer}>
        <Card className={classes.modal}>
          <CardContent className={classes.modalContent}>
            <Box className={classes.modalTitleContainer}>
              <Box className={classes.modalTitleAndIcon}>
                <Typography variant="h4" color="primary" fontWeight="bold">
                  Habilitar alumno
                </Typography>
              </Box>
              <IconButton onClick={onClose} disabled={loading}>
                <CloseIcon color="primary" />
              </IconButton>
            </Box>
            <Box className={classes.modalBody}>
              <Typography variant="body1" textAlign="center">
                El alumno quedará con estado <strong>matriculado</strong>
                y podrá ver toda la información de las secciones y guías
                asociadas a sus programas.
              </Typography>
            </Box>
            <Box className={classes.modalButtonsContainer}>
              <CustomButton
                text="Cancelar"
                colorType="tertiary"
                onClick={onClose}
                disabled={loading}
                icon={<CloseIcon />}
              />
              <CustomButton
                text="Habilitar"
                colorType="primary"
                onClick={onConfirm}
                disabled={loading}
                loading={loading}
                icon={<HowToRegIcon />}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Modal>
  );
}

export default EnableEnrollmentModal;
